module.exports = __webpack_public_path__ + "img/pluto57.07ff1c22.jpg";